import React from 'react'

import Header from './Header';
import Powerplant from './Powerplant';
import Category from './Category';



function HomePage() {
    return ( 
        <>
        <Header />
        <Powerplant />
        <Category />
        </>
     );
}

export default HomePage;